import { combineReducers } from 'redux';
import Auth from './auth/reducers';
import Customer from './customers/reducers';
import Layout from './layout/reducers';
import User from './users/reducers';
import Products from './products/reducers';
import Services from './services/reducers';
import Events from './events/reducers';
import Poojaris from './poojari/reducers';
import Rituals from './rituals/reducers';
import Temples from './temples/reducers';
import Vendors from './vendors/reducers';
import Stalls from './stalls/reducers';
import templeAnalytics from './templeAnalytics/reducers';
import Orders from './orders/reducers';
import AppVersions from './appVersions/reducers';
import Categories from './categories/reducers';
import Dashboard from './dashboard/reducers';

export default combineReducers({
    Auth,
    Layout,
    User,
    Customer,
    Products,
    Services,
    Events,
    Poojaris,
    Rituals,
    Temples,
    Vendors,
    Stalls,
    templeAnalytics,
    Orders,
    AppVersions,
    Categories,
    Dashboard
});
